
<template>
  <div class="animated fadeIn purchaseorders--purchaseorders-list">
    <div v-if="isUnpublishedQboPage">
      <h6> Please select a PO to publish to Quickbooks. Note: A PO should be authorized before publishing to Quickbooks. </h6>
    </div>  
    <div class="d-flex justify-content-start align-items-end mb-2" v-if="isAccountPage">
					<b-form-group label="Status" class="mr-2">
						<b-form-select v-model="filterObj.statusId" @change="onSearch">
							<option :value="null">All</option>
							<option v-for="option in sortSelect(purchaseOrdersStatusOptions)" :key="option.name" :value="option.id">
								{{option.name}}</option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Purchase Order Number" class="mr-2">
						<b-form-input v-model="filterObj.poNumber" @input="onSearch"  size="sm" />
					</b-form-group>
					<b-form-group label="Company" class="mr-2">
						<b-form-input v-model="filterObj.companyName" @input="onSearch" size="sm" />
					</b-form-group>
          <b-form-group label="Past Due" class="mr-2">
          <b-form-checkbox v-model="filterObj.pastDue" @input="onSearch" value="true" unchecked-value="" />
			</b-form-group>
					<b-form-group label="Sales Rep" class="mr-2">
						<b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
							<option :value="null">All</option>
							<option
								v-for="(selectRep, indexRep) in sortSelect(salesReps)"
								:key="indexRep"
								:value="selectRep.id"
							>{{ selectRep.name }}</option>
						</b-form-select>
					</b-form-group>
					<date-range-picker :dateFrom="filterObj.dateFrom" :dateTo="filterObj.dateTo" @handleSearch="onSearch"></date-range-picker>
					<b-button class="mr-2" size="sm" @click="clearFilter">Clear filters</b-button>
          <div class="buttons-panel" v-if="checkClaim(CAN_POST_PAYMENT) && !isUnpublishedQboPage">
            <b-button size="sm" variant="primary" class="mr-2" @click="add()">
              <i class="fa fa-plus" aria-hidden="true"></i>
              Post Payment
            </b-button>
          </div>
          <div v-else-if="checkClaim(CAN_EDIT_POS) && isUnpublishedQboPage">
            <b-button size="sm" variant="primary" @click="onSaveToQbo" :disabled="isQboLoading || checkedRowItemIdsArr.length == 0">
              <i v-show="isQboLoading" class="fa fa-spinner fa-pulse fa-fw mr-2"></i> 
              <span v-if="isQboLoading">Publishing...</span>
              <span v-else>
                Publish {{ checkedRowItemIdsArr.length }} selected PO{{checkedRowItemIdsArr.length > 1 ? 's' : '' }} to Quickbooks
              </span>
              
            </b-button>
          </div>
				</div>
    <grid-component
        isResizable
        isReorderable
        isSortable
        :canEdit="checkClaim(CAN_EDIT_POS)"
        :canDelete="checkClaim(CAN_DELETE_POS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="columnFields"
        :onEdit="pushToDetails"
        :handleRowClick="onRowClick"
        :sortBy="gridInfo.sortBy"
        :sortOrder="gridInfo.sortOrder"
        :sortMethod="onSort"
        :checkBoxValues="checkedRowItemIdsArr"
        @checkedItem="checkedRowItemIdsArr=$event"
      />
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { debounce, unionBy } from 'lodash';
import { GRID_ID, SEARCH_DEBOUNCE_TIME, CHECKBOX_GRID_COLUMN } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from '@/pages/PurchaseOrders/fields';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';

export default {
  components: {
    GridSettings,
    GridComponent,
    DateRangePicker
  },
  props: {
    partId: {
      type: [Number, String],
      default: 0,
    },
    isParentList: {
      type: Boolean,
      default: false,
    },
    purchaseOrdersParentList: {
      type: Array,
      default: () => [],
    },
    isAvailableParts: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: 0
    },
    isAccountPage: {
      type: Boolean,
      default: false,
    }, isClear: {
      type: Boolean,
      default: false,
    },
    gridId: {
      type: String,
      default: GRID_ID.PURCHASE_ORDERS
    }, filterPageName: {
      type: String,
      default: 'sharedPoPage',
    }, forPage: {
      type: String,
      default: '',
    },
    isUnpublishedQboPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: gridFields,
      selectedRowItemId: 0,
      currentParams: {
        partId: 0,
        companyId: 0,
      },
      customFilters: {},
      purchaseOrdersStatusOptions:[
					{ id: 153, name: 'Cancelled' },
					{ id: 154, name: 'Closed' },
					{ id: 155, name: 'Open' },
					{ id: 156, name: 'Partially Received' },
					{ id: 157, name: 'Received' },
				],
      selectedPurchaseOrderRow: {},
      isQboLoading: false,
      checkedRowItemIdsArr: []
    };
  },
  computed: {
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('purchaseorders', [
      'purchaseorders',
      'gridList',
      'pageInfo',
      'filters',
      'purchaseOrdersFiltered',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('shippingReceiving', ['poPageInfo']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      let itemData = (this.isParentList) ? this.purchaseOrdersParentList : (this.isAccountPage) ? this.gridList : this.purchaseOrdersFiltered;
      return itemData.map((purchaseorder) => ({ ...purchaseorder, selected: purchaseorder.id === this.selectedRowItemId }));
    },
    filterObj() {
      return this.filters[this.filterPageName] || {}
    },
    gridInfo() {
      return this.isParentList ? this.poPageInfo : this.pageInfo;
    },
    columnFields() {
      let columnFields = [ ...this.fields ];

      if (this.isUnpublishedQboPage) {
        columnFields.unshift(CHECKBOX_GRID_COLUMN);
      }
      return columnFields;
    }
  },
  methods: {
    ...mapActions('purchaseorders', [
        'getAll', 'sortGrid', 'getPage', 'remove', 'search', 'select','clearFilters', 'getByCompanyAndParts', 'getByParts', 'getOrdersByAvailablePart', 'getPurchaseOrdersFiltered', 'multiSaveToQuickbooks']),
    ...mapMutations('purchaseorders', ['clearPurchaseOrdersItems','setItem','setFilters']),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('salesReps', ['getSalesReps']),
    onSort($e) {
      if (this.isParentList) {
        this.$emit('onSort', $e);
      } else {
        this.sortGrid($e);
      }
      
    },
    onSearch: debounce(function(data=false) {
      if(this.isAccountPage) {
        if(typeof data === "object") { Object.assign(this.filterObj,data) }
        this.isUnpublishedQboPage ? this.filterObj.IsQboUnpublished = true : this.filterObj.hasBalance=true;
      }
      this.search({'filters':this.filterObj,page:this.filterPageName});
    }, SEARCH_DEBOUNCE_TIME),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.$emit('selectedSourceObj', row.dataItem);
      this.selectedPurchaseOrderRow = row.dataItem
    },
    add() {
      this.$router.push({
        name: 'billpayments.add', params: {
          sourceId: 1,
          suggestion: { id: this.selectedPurchaseOrderRow.companyId, name: this.selectedPurchaseOrderRow.companyName },
          total: this.selectedPurchaseOrderRow.balance,
        },
      });
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'purchaseorders.edit',
        params: { id: row.id },
      });
    },
    async getPurchaseOrders() {
      if (this.isAccountPage) {
        this.isUnpublishedQboPage ? this.filterObj.IsQboUnpublished = true : this.filterObj.hasBalance=true;
        // this.filterObj.hasBalance = this.isAccountPage;
        this.setFilters(this.filterObj);
        await this.getAll({});
      } else {
        await this.getPurchaseOrdersFiltered(this.customFilters);
      }
    },
    clearFilter(callSearch = true) {
        this.checkedRowItemIdsArr = [];
        this.clearObject(this.filterObj);
        this.isUnpublishedQboPage ? this.filterObj.IsQboUnpublished = true : this.filterObj.hasBalance=true;
        if (callSearch) {
            this.search({'filters':this.filterObj,page:this.filterPageName});
        }
    },
    async onSaveToQbo() {
      try {
        this.isQboLoading = true;
        const response = await this.multiSaveToQuickbooks(this.checkedRowItemIdsArr);

        if (response.status == 200) {
          this.getAll({});
          this.checkedRowItemIdsArr = [];
          this.$snotify.success('Successfully published to quickbooks');
        }

        this.isQboLoading = false;
        
      } catch(e) {
        this.isQboLoading = false;
      } 
    },
    /*clearFilter(callSearch = true) {
				this.clearFilters(this.filterPageName);
				Object.keys(this.filters).forEach(filterName => {
					this.filters[filterName] = null;
				});
        this.filterObj.hasBalance=true;
				this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
        if (callSearch) {
          this.search({'filters':this.filterObj,page:this.filterPageName});
        }
			},*/
  },
  watch: {
    async partId() {
      if (this.isAvailableParts) {
        await this.getOrdersByAvailablePart(this.partId);
      } else {
        await this.getByParts(this.partId);
      }
    },
  },
  mounted() {
    this.setItem({ resource:'filterPage', payload: this.filterPageName });
    if (this.isClear) {
      this.pageInfo.pageNumber = 1;
      this.clearFilter(false);
    } else {
      this.clearPurchaseOrdersItems();
      let goGetData = (this.isAccountPage)?true: false;

      if (this.companyId) {
        goGetData = true;
        this.customFilters.companyId = parseInt(this.companyId);
      }

      if (this.isAccountPage) {
        this.getPurchaseOrders();
      }
      // this.onGetData();
      // if(this.isAccountPage) 
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#purchaseorders-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#purchaseorders-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.purchaseorders {
  &--purchaseorders-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
